import { PromotionType, PromotionTypes } from 'src/constants/PromotionType';

export function isBuyOneGetOnePromotion(promotionType: PromotionType | undefined): boolean {
    return promotionType === PromotionTypes.BUY_ONE_GET_ONE;
}
